export default __webpack_public_path__ + "static/alpha-de7f2a8488b79122c91ed4b5216e7ca4.png";